import CommonButton from 'components/Buttons/CommonButton';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import services from 'services';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import { actionType, modalActionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

const UndoValidate = () => {
  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();
  const saveDocument = utils.hooks.useSaveDocument(false, 'modal');
  const { checkDocuments } = useCheckBeforeAction(actionType.SANITY_CHECK);
  const protocol = useSelector(selectors.documents.selectActiveDocumentID);
  const idProgram = useSelector(selectors.app.getProgramCode);
  const documentHeader = useSelector(selectors.documents.selectDocumentHeader);
  const idTemplate = useSelector(selectors.documents.selectActiveTemplateId);

  const reloadPage = () => {
    if (protocol && idTemplate) {
      dispatch(actions.documents.setDocumentHeader(protocol, idProgram, idTemplate));
      dispatch(actions.documents.setDocumentFields(protocol, idProgram));
    }
  };

  const undoValidate = async () => {
    if (!protocol) return;
    const body = utils.documents.buildLeaseValidationRequest(protocol, idProgram, 'undo_validate');

    try {
      const {
        data: {
          store: { RESPONSE },
        },
      } = await services.leaseValidate(body, 'modal');
      dispatch(actions.modal.closeModal());
      utils.documents.handlePayloadUpdate(RESPONSE, protocol, dispatch);
      utils.app.notify('success', t('undo_validate'), 10000);
      reloadPage();
    } catch (e) {
      utils.app.notify('fail', t('error-undo_validate'), 10000);
      dispatch(actions.modal.closeModal());
    }
  };

  const onConfirm = async () => {
    try {
      const docFree = await checkDocuments();
      if (!docFree) return;
      const val = await saveDocument();
      if (val === null || val === undefined) {
        return;
      }
      undoValidate();
    } catch (error) {
      dispatch(actions.modal.closeModal());
    }
  };

  const isUndoValidateDisabled = !documentHeader?.showUndoValidate;

  return (
    <CommonButton
      id="undo-validate-btn"
      action={() =>
        dispatch(
          actions.modal.openModal(modalActionType.documents.VALIDATION_CONFIRM_MODAL, {
            title: 'undo_validate_confirmation',
            subTitle: 'once_undo_validated_no_changes',
            onConfirm: onConfirm,
          }),
        )
      }
      scope="tertiary"
      value={t('undo-validate')}
      customIcon="undo-alt"
      disabled={!utils.user.isActionEnabled(records, actionType.UNDO_VALIDATE) || isUndoValidateDisabled}
    />
  );
};

export default UndoValidate;
